import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { useSelector } from "react-redux";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from '../../ToolTip/TooltipComp';
import { ReactComponent as StarIcon } from "../../../Icons/darkstar.svg";
export default function NameInfo({ data, question }) {
  // console.log(data,question,'check check check')
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const onCLickFavorite = () => {
  };
  const userProfile = () => {
    let img = "";
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );
    if (img !== undefined) {
      return `data:image/JPEG;base64,${img.img}`;
    }
  };
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
          {arr.map((item, index) => (
            <div className="mb-1">
              {" "}
              <AttachmentBox key={index} attachment={item} />
            </div>
          ))}
      </div>
    );
  };
  return (
    <>
      <div style={infoContainer}>
        <div>
          {question.docType === "expertqa" && (
            <Avatar
              size={48}
              src={userProfile() || require("../../../Images/cliente.png")}
            ></Avatar>
          )}
          {question.docType !== "expertqa" && (
            <Avatar
              size={48}
              src={require("../../../Images/bot-icon.png")}
            ></Avatar>
          )}
        </div>
        <div style={dateInfoStyles}>
          <div>
            {question.docType === "expertqa" && (
              <div style={textStyles}>
                {data.expert.firstName} {data.expert.lastName}&nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )}
            {question.docType !== "expertqa" && (
              <div style={textStyles}>
                {question.docName === "" || question.docName === undefined
                  ? `${data.expert.firstName} ${data.expert.lastName}`
                  : question.docName}
              </div>
            )}
            <div style={dateStyles}>
              {data.answeredTimestamp < data.lastUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.lastUpdatedTimestamp
                  ? data.lastUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>
          <div style={{display:'flex', alignItems:'center'}}>
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    // fontWeight: "500",
                  }}
                >
                  <TooltipComp title={"Total view count"}>
                                                      <ViewIcon /> 
                                                    </TooltipComp>
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
              )}
            {question.docType === "expertqa" && data.internal && (
              <div style={{ marginRight: "6px" }}>
                <TooltipComp title={"Internal Answer"}>
                  <InternalIcon /> 
                </TooltipComp>
              </div>
            )}
            {question.docType === "expertqa" &&
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{  }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
              {/* {!data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginLeft:'5px'}}></i></span></TooltipComp>
              </div>} */}
          </div>
        </div>
      </div>
    </>
  );
}
